module.exports = __webpack_public_path__ + "img/construction-catalog.5f384679.webp";